// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Article__wrapper-afa124 {
  display: grid;
  align-content: start;
  height: 100vh;
}

.Article__container-b44a06 {
  width: 100%;
  overflow-y: auto;
  scroll-padding: 16px 0px;
}

.Article__content-aa2662 {
  max-width: calc(var(--max-width-article-layout) + 96px);
  padding: 40px 24px;
  margin: 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChannelPopups/Article/styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,oBAAA;EACA,aAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,wBAAA;AACF;;AAEA;EACE,uDAAA;EACA,kBAAA;EACA,cAAA;AACF","sourcesContent":[".wrapper {\n  display: grid;\n  align-content: start;\n  height: 100vh;\n}\n\n.container {\n  width: 100%;\n  overflow-y: auto;\n  scroll-padding: 16px 0px;\n}\n\n.content {\n  max-width: calc(var(--max-width-article-layout) + 96px);\n  padding: 40px 24px;\n  margin: 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Article__wrapper-afa124`,
	"container": `Article__container-b44a06`,
	"content": `Article__content-aa2662`
};
module.exports = ___CSS_LOADER_EXPORT___;
